import React from "react";

export const iconInHome = {
  security: (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      width="120px"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="18 0 146.754 146.754"
      // style="enable-background:new 0 0 146.754 146.754;"
      // xml:space="preserve"
    >
      <path
        style={{ fill: "#336699" }}
        d="M78.794,146.754H67.96c-26.941,0-48.859-21.918-48.859-48.859V64.063c0-1.381,1.119-2.5,2.5-2.5
    h8.234V43.542C29.834,19.533,49.368,0,73.377,0s43.542,19.533,43.542,43.542v18.021h8.234c1.381,0,2.5,1.119,2.5,2.5v33.831
    C127.653,124.835,105.735,146.754,78.794,146.754z M24.101,66.563v31.331c0,24.184,19.675,43.859,43.859,43.859h10.834
    c24.184,0,43.859-19.675,43.859-43.859V66.563H24.101z M34.834,61.563h77.084V43.542C111.919,22.29,94.629,5,73.377,5
    C52.125,5,34.834,22.29,34.834,43.542V61.563z M77.875,120.55h-8.998c-1.381,0-2.5-1.119-2.5-2.5v-13.617
    c-3.198-2.257-5.13-5.927-5.13-9.904c0-6.688,5.441-12.129,12.129-12.129s12.129,5.441,12.129,12.129
    c0,3.978-1.932,7.647-5.13,9.904v13.617C80.375,119.431,79.256,120.55,77.875,120.55z M71.378,115.55h3.998v-12.509
    c0-0.926,0.512-1.776,1.33-2.209c2.345-1.242,3.801-3.657,3.801-6.302c0-3.931-3.198-7.129-7.129-7.129
    c-3.931,0-7.129,3.198-7.129,7.129c0,2.646,1.457,5.06,3.801,6.302c0.818,0.433,1.33,1.283,1.33,2.209V115.55z"
      />
    </svg>
  ),
  mail: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      width="130px"
      // style="enable-background:new 0 0 256 256;"
      xmlSpace="preserve"
    >
      <g
        fill="#336699"
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
      >
        <path
          className="ml0"
          d="M82.6,78.2H7.4c-4.1,0-7.4-3.3-7.4-7.4V19.2c0-4.1,3.3-7.4,7.4-7.4h75.2c4.1,0,7.4,3.3,7.4,7.4v51.7
		C90,74.9,86.7,78.2,82.6,78.2z M7.4,13.8c-3,0-5.4,2.4-5.4,5.4v51.7c0,3,2.4,5.4,5.4,5.4h75.2c3,0,5.4-2.4,5.4-5.4V19.2
		c0-3-2.4-5.4-5.4-5.4L7.4,13.8L7.4,13.8z"
        />
        <path
          className="ml0"
          d="M45,53.8c-5.1,0-9.9-2.1-13.3-5.9L2.1,15.4l1.5-1.3l29.6,32.5c3,3.3,7.4,5.2,11.9,5.2s8.8-1.9,11.9-5.2
		l29.6-32.5l1.5,1.3L58.3,47.9C54.9,51.6,50.1,53.8,45,53.8z"
        />
        <rect
          x="-3.1"
          y="59.9"
          transform="matrix(0.7052 -0.7091 0.7091 0.7052 -38.0803 30.195)"
          className="ml0"
          width="40.8"
          height="2"
        />
        <rect
          x="71.7"
          y="40.5"
          transform="matrix(0.7089 -0.7053 0.7053 0.7089 -21.7677 69.0189)"
          className="ml0"
          width="2"
          height="40.8"
        />
      </g>
    </svg>
  ),
  observability: (
    <svg
      version="1.1"
      width="140px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511 511"
      // enable-background="new 0 0 511 511"
    >
      <g style={{ fill: "#336699" }}>
        <path d="m485.729,236.892c-0.21-0.313-0.437-0.618-0.699-0.904l-.718-.783c-1.699-1.99-3.467-3.92-5.3-5.786l-96.189-105.006c-0.201-0.253-0.42-0.497-0.659-0.728-9.578-9.302-21.964-14.748-35.186-15.565-5.499-9.814-15.961-16.12-27.478-16.12-17.369,0-31.5,14.131-31.5,31.5v40 8 24.5h-65v-24.5-8-40c0-17.369-14.131-31.5-31.5-31.5-11.514,0-21.98,6.307-27.481,16.12-13.221,0.817-25.607,6.263-35.185,15.565-0.237,0.23-0.456,0.472-0.655,0.725l-96.192,105.009c-1.833,1.866-3.601,3.795-5.3,5.786l-.718,.783c-0.262,0.286-0.489,0.591-0.699,0.904-15.783,19.241-25.27,43.837-25.27,70.608 0,61.481 50.019,111.5 111.5,111.5s111.5-50.019 111.5-111.5c0-2.859-0.109-5.694-0.322-8.5h65.643c-0.213,2.806-0.322,5.641-0.322,8.5 0,61.481 50.019,111.5 111.5,111.5s111.501-50.019 111.501-111.5c0-26.771-9.487-51.367-25.271-70.608zm-182.729-113.392c0-9.098 7.402-16.5 16.5-16.5 3.445,0 6.709,1.079 9.415,2.958-10.059,2.743-18.985,8.249-25.915,15.651v-2.109zm-95,0v2.11c-6.93-7.403-15.856-12.908-25.915-15.651 2.706-1.879 5.97-2.958 9.415-2.958 9.098-0.001 16.5,7.401 16.5,16.499zm-96.5,280.5c-53.21,0-96.5-43.29-96.5-96.5 0-23.702 8.594-45.431 22.823-62.246l5.227-5.706c17.494-17.62 41.719-28.548 68.45-28.548 53.21,0 96.5,43.29 96.5,96.5s-43.29,96.5-96.5,96.5zm0-208c-11.548,0-22.691,1.765-33.174,5.039l61.278-66.894c0.012-0.013 0.024-0.026 0.036-0.039 7.554-7.166 17.428-11.106 27.86-11.106 22.332,0 40.5,18.168 40.5,40.5v8 24.5h-16.5c-0.172,0-0.342,0.006-0.511,0.017-2.181-0.209-4.427,0.533-6.077,2.218-2.898,2.959-2.849,7.708 0.111,10.606 11.432,11.196 18.88,25.313 21.697,40.7-19.601-32.082-54.951-53.541-95.22-53.541zm176.5,88h-65v-20.5c0-19.088-5.781-37.238-16.524-52.5h98.048c-10.743,15.262-16.524,33.411-16.524,52.5v20.5zm37.977-75.159c2.191-2.146 2.855-5.409 1.677-8.241-1.178-2.831-3.958-4.642-7.028-4.617l-1.176,.017h-16.45v-24.5-8c0-22.332 18.168-40.5 40.5-40.5 10.432,0 20.306,3.94 27.86,11.105 0.012,0.013 0.024,0.026 0.036,0.039l61.278,66.894c-10.483-3.273-21.626-5.038-33.174-5.038-40.269,0-75.619,21.459-95.219,53.542 2.816-15.387 10.265-29.505 21.696-40.701zm73.523,195.159c-53.21,0-96.5-43.29-96.5-96.5s43.29-96.5 96.5-96.5c26.731,0 50.956,10.928 68.449,28.547l5.227,5.706c14.23,16.816 22.824,38.545 22.824,62.247 0,53.21-43.29,96.5-96.5,96.5z" />
        <path d="m111.5,228c-43.836,0-79.5,35.664-79.5,79.5s35.664,79.5 79.5,79.5 79.5-35.664 79.5-79.5-35.664-79.5-79.5-79.5zm0,144c-35.565,0-64.5-28.935-64.5-64.5s28.935-64.5 64.5-64.5 64.5,28.935 64.5,64.5-28.935,64.5-64.5,64.5z" />
        <path d="m399.5,228c-43.836,0-79.5,35.664-79.5,79.5s35.664,79.5 79.5,79.5 79.5-35.664 79.5-79.5-35.664-79.5-79.5-79.5zm0,144c-35.565,0-64.5-28.935-64.5-64.5s28.935-64.5 64.5-64.5 64.5,28.935 64.5,64.5-28.935,64.5-64.5,64.5z" />
        <path d="m399.5,260c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5c17.92,0 32.5,14.58 32.5,32.5 0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5c0-26.191-21.309-47.5-47.5-47.5z" />
        <path d="m111.5,260c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5c17.92,0 32.5,14.58 32.5,32.5 0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5c0-26.191-21.309-47.5-47.5-47.5z" />
      </g>
    </svg>
  ),
  inrete: (
    <svg
      width="180px"
      height="30px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 552 90.5"
      // "enable-background:new 0 0 552 90.5;"
    >
      <g id="Page-1">
        <path
          id="Combined-Shape"
          className="logo-fill"
          d="M166,0.3l-20,90L69.4,52L61,90.2h-5l15.9-69.8L76,0.2l76.7,38.4l8.8-38.3L166,0.3z
		 M361,0.2l-1.1,5h-35l-4.5,20H356l-1.1,5h-35.6l-12.2,55h35l-1.1,5h-75l20-90H361z M467,0.2l-1.1,5h-26l-18.9,85h-39.9l18.9-85H370
		l1.1-5H467z M551,0.2l-1.1,5h-35l-4.5,20H546l-1.1,5h-35.6l-12.2,55h35l-1.1,5h-75l20-90H551z M61,0.2l-20,90H1l20-90H61z
		 M221.3,0.3l0.4,0c34.2,0,49,17.9,43,40c-5.5,20.6-27.2,33.2-54.1,34.8c10.5,7.4,24.2,10.2,35.2,10.2l0,0l-5,5
		c-8.6,0-28.3-3.7-36.8-14.4l0,0l-3.1,14.4H161l20-90h39.9c0.3,0,0.5,0,0.8,0L221.3,0.3z M220.3,5.3h-0.5l-14.5,65
		c0.2,0,0.4,0,0.6,0c27.2,0,48.1-11.2,53.2-30C264.2,21.5,250.8,5.3,220.3,5.3L220.3,5.3z"
        />
      </g>
    </svg>
  ),
  traffic: (
    <svg
      width="190"
      // height="100"
      viewBox="2 0 26.458333 26.458334"
      version="1.1"
      id="svg8"
    >
      <defs id="defs2" />
      <g id="layer1" transform="translate(0,-270.54165)">
        <g id="g1110">
          <g transform="translate(-0.16667493,-0.40023445)" id="g904">
            <ellipse
              className="ellipse-1"
              id="path826-1"
              cx="13.395842"
              cy="286.50964"
              rx="7.5408292"
              ry="2.9293859"
            />
            <rect
              className="rect-1"
              id="rect845"
              width="15.111696"
              height="5.0055671"
              x="5.8744454"
              y="281.71002"
            />
            <ellipse
              className="ellipse-2"
              id="path826"
              cx="13.392711"
              cy="281.83246"
              rx="7.5108109"
              ry="2.9296446"
            />
            <path className="path-1" d="m 5.8744454,281.71002 v 5.00556" id="path847" />
            <path className="path-1" d="m 20.915861,281.71106 v 5.00556" id="path847-9" />
            <path
              className="path-2"
              d="m 14.410815,280.21713 -0.756797,-0.12394 2.226652,-0.72434 0.341717,1.14733 -0.70673,-0.11615 -1.069857,1.11008 -1.100672,-0.18347 z"
              id="path864"
            />
            <path
              className="path-2"
              d="m 10.381971,281.72612 -0.3844203,0.39447 2.3130943,-0.51386 -0.64105,-1.21698 -0.546068,0.56791 -3.4482612,-0.57404 -0.7413226,0.77297 z"
              id="path875"
            />
            <path
              className="path-2"
              d="m 12.368145,283.66794 0.879037,0.1461 -2.229737,0.54905 -0.322587,-0.97005 0.564306,0.0919 1.18339,-1.21646 1.11308,0.16813 c -0.444088,0.47435 -0.827258,0.86444 -1.187489,1.23133 z"
              id="path877"
            />
            <path
              className="path-2"
              d="m 19.020028,283.1569 -3.285832,-0.54735 -0.503409,0.53128 -0.620827,-1.15182 2.38125,-0.6842 -0.521797,0.54183 c 1.209955,0.19671 2.557845,0.42814 3.289141,0.54766 0,0 -0.170595,0.17004 -0.738526,0.7626 z"
              id="path879"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  traffic2: (
    <svg width="170px" viewBox="2 0 26.458333 26.458334" version="1.1" id="svg8">
      <defs id="defs2" />

      <g
        id="layer1"
        transform="translate(0,-270.54165)"
        //  style="display:inline"
      >
        <g
          id="g1110"
          transform="matrix(1.4490874,0,0,1.2176118,-5.7005405,-61.739517)"
          className="r-icon"
        >
          <g transform="translate(-0.16667493,-0.40023445)" id="g904" className="r-icon">
            <path
              className="r-icon-1"
              id="path826-1"
              d="m 20.924581,286.50964 a 7.528739,2.9293859 0 0 1 -3.812346,2.54761 7.528739,2.9293859 0 0 1 -7.5761033,-0.0325 7.528739,2.9293859 0 0 1 -3.6672025,-2.57966"
            />
            <ellipse
              className="r-icon-1"
              id="path826"
              cx="13.392711"
              cy="281.83246"
              rx="7.5108109"
              ry="2.9296446"
            />
            <path className="r-icon-2" d="m 5.8744454,281.71002 v 5.00556" id="path847" />
            <path
              className="r-icon-2"
              d="m 20.915861,281.71106 v 5.00556"
              id="path847-9"
            />
            <path
              className="r-icon-3"
              d="m 14.410815,280.21713 -0.756797,-0.12394 2.226652,-0.72434 0.341717,1.14733 -0.70673,-0.11615 -1.069857,1.11008 -1.100672,-0.18347 z"
              id="path864"
            />
            <path
              className="r-icon-3"
              d="m 10.381971,281.72612 -0.3844203,0.39447 2.3130943,-0.51386 -0.64105,-1.21698 -0.546068,0.56791 -3.4482612,-0.57404 -0.7413226,0.77297 z"
              id="path875"
            />
            <path
              className="r-icon-3"
              d="m 12.368145,283.66794 0.879037,0.1461 -2.229737,0.54905 -0.322587,-0.97005 0.564306,0.0919 1.18339,-1.21646 1.11308,0.16813 c -0.444088,0.47435 -0.827258,0.86444 -1.187489,1.23133 z"
              id="path877"
            />
            <path
              className="r-icon-3"
              d="m 19.020028,283.1569 -3.285832,-0.54735 -0.503409,0.53128 -0.620827,-1.15182 2.38125,-0.6842 -0.521797,0.54183 c 1.209955,0.19671 2.557845,0.42814 3.289141,0.54766 0,0 -0.170595,0.17004 -0.738526,0.7626 z"
              id="path879"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  metaverse: (
    <svg
      width="200px"
      version="1.1"
      viewBox="0 0 700 700"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ fill: "#336699", strokeWidth: "1px" }}>
        <path d="m603.75 240.62h-17.5c-0.39844 0-0.78125 0.0625-1.1719 0.085938-2.3828-14.059-8.5312-27.211-17.797-38.055-9.2617-10.844-21.289-18.977-34.805-23.527l-48.594-28.207c-21.5-12.871-46.094-19.672-71.152-19.672h-125.46c-25.105 0-49.738 6.8242-71.266 19.742-0.21484 0.12891-0.42578 0.26172-0.63672 0.39844l-38.051 25.109c-15.684 3.1172-30.047 10.93-41.191 22.395-11.141 11.469-18.535 26.051-21.203 41.816-0.39062-0.023438-0.77344-0.085938-1.1719-0.085938h-17.5c-6.9609 0.007812-13.633 2.7773-18.555 7.6953-4.918 4.9219-7.6875 11.594-7.6953 18.555v70c0.007812 6.9609 2.7773 13.633 7.6953 18.555 4.9219 4.918 11.594 7.6875 18.555 7.6953h17.5c0.39844 0 0.78125-0.0625 1.1719-0.085938 3.0938 18.348 12.578 35.008 26.777 47.035 14.199 12.027 32.191 18.645 50.801 18.676h108.11c3.6172 0 7.1484-1.1211 10.105-3.2109 2.9531-2.0898 5.1875-5.0469 6.3945-8.457l8.2422-23.332h49.289l8.2461 23.332h-0.003906c1.207 3.4102 3.4414 6.3672 6.3945 8.457 2.957 2.0898 6.4883 3.2109 10.105 3.2109h108.11c18.609-0.03125 36.602-6.6484 50.801-18.676 14.199-12.027 23.684-28.688 26.777-47.035 0.39062 0.027344 0.77344 0.085938 1.1719 0.085938h17.5c6.9609-0.007812 13.633-2.7773 18.555-7.6953 4.918-4.9219 7.6875-11.594 7.6953-18.555v-70c-0.007812-6.9609-2.7773-13.633-7.6953-18.555-4.9219-4.918-11.594-7.6875-18.555-7.6953zm-490 105h-17.5c-4.832 0-8.75-3.918-8.75-8.75v-70c0-4.832 3.918-8.75 8.75-8.75h17.5zm111.26-179.63c18.809-11.285 40.328-17.246 62.262-17.246h125.46c21.934 0 43.453 5.9609 62.262 17.246l15.512 9.0039h-279.14zm343.74 184c0 16.246-6.4531 31.824-17.941 43.309-11.484 11.488-27.062 17.941-43.309 17.941h-108.11l-12.367-35h-74.039l-12.367 35h-108.11c-16.246 0-31.824-6.4531-43.309-17.941-11.488-11.484-17.941-27.062-17.941-43.309v-96.25c0-16.246 6.4531-31.824 17.941-43.309 11.484-11.488 27.062-17.941 43.309-17.941h315c16.246 0 31.824 6.4531 43.309 17.941 11.488 11.484 17.941 27.062 17.941 43.309zm43.75-13.125c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-17.5v-87.5h17.5c2.3203 0 4.5469 0.92188 6.1875 2.5625s2.5625 3.8672 2.5625 6.1875z" />
        <use x="70" y="625.625" xlinkHref="#h" />
        <use x="86.054688" y="625.625" xlinkHref="#c" />
        <use x="96.839844" y="625.625" xlinkHref="#a" />
        <use x="111.679687" y="625.625" xlinkHref="#m" />
        <use x="126.4375" y="625.625" xlinkHref="#b" />
        <use x="136.894531" y="625.625" xlinkHref="#a" />
        <use x="151.730469" y="625.625" xlinkHref="#l" />
        <use x="175.007812" y="625.625" xlinkHref="#k" />
        <use x="190.664062" y="625.625" xlinkHref="#j" />
        <use x="212.539062" y="625.625" xlinkHref="#i" />
        <use x="236.667969" y="625.625" xlinkHref="#g" />
        <use x="251.613281" y="625.625" xlinkHref="#z" />
        <use x="268.285156" y="625.625" xlinkHref="#y" />
        <use x="283.207031" y="625.625" xlinkHref="#g" />
        <use x="298.148438" y="625.625" xlinkHref="#h" />
        <use x="314.203125" y="625.625" xlinkHref="#x" />
        <use x="332.511719" y="625.625" xlinkHref="#w" />
        <use x="351.105469" y="625.625" xlinkHref="#e" />
        <use x="367.140625" y="625.625" xlinkHref="#v" />
        <use x="390.507812" y="625.625" xlinkHref="#f" />
        <use x="404.449219" y="625.625" xlinkHref="#f" />
        <use x="418.386719" y="625.625" xlinkHref="#e" />
        <use x="70" y="647.5" xlinkHref="#u" />
        <use x="79.515625" y="647.5" xlinkHref="#c" />
        <use x="90.304688" y="647.5" xlinkHref="#d" />
        <use x="105.332031" y="647.5" xlinkHref="#t" />
        <use x="135.742188" y="647.5" xlinkHref="#b" />
        <use x="146.199219" y="647.5" xlinkHref="#s" />
        <use x="161.773438" y="647.5" xlinkHref="#a" />
        <use x="184.222656" y="647.5" xlinkHref="#r" />
        <use x="202.53125" y="647.5" xlinkHref="#d" />
        <use x="217.558594" y="647.5" xlinkHref="#q" />
        <use x="233.132812" y="647.5" xlinkHref="#p" />
        <use x="256.320312" y="647.5" xlinkHref="#e" />
        <use x="272.355469" y="647.5" xlinkHref="#c" />
        <use x="283.140625" y="647.5" xlinkHref="#d" />
        <use x="298.171875" y="647.5" xlinkHref="#o" />
        <use x="305.667969" y="647.5" xlinkHref="#a" />
        <use x="320.503906" y="647.5" xlinkHref="#n" />
        <use x="333.472656" y="647.5" xlinkHref="#b" />
      </g>
    </svg>
  ),
  metaverse2: (
    <svg
      data-name="Layer 1"
      id="Layer_1"
      width="320px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="cls-1"
        d="M324.4,323.75a16.74,16.74,0,0,1-12.67-5.83c-11.05-12.82-30.39-21.32-52.41-21.32s-41.35,8.5-52.4,21.32a16.74,16.74,0,0,1-12.67,5.83h-24a9.76,9.76,0,0,1-9.77-9.76V233.46a9.76,9.76,0,0,1,9.77-9.76H341.78a9.76,9.76,0,0,1,9.77,9.76V314a9.76,9.76,0,0,1-9.77,9.76Z"
      />
      <path
        class="cls-1"
        d="M229.83,188.25h52.34a35.45,35.45,0,0,1,35.45,35.45v0a0,0,0,0,1,0,0H194.38a0,0,0,0,1,0,0v0A35.45,35.45,0,0,1,229.83,188.25Z"
      />
      <rect class="cls-1" height="38.63" width="24.99" x="135.46" y="254.03" />
      <rect class="cls-1" height="38.63" width="24.99" x="351.55" y="254.03" />
    </svg>
  ),
  aiml: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="182.48"
      height="77.839"
      viewBox="59.276 42.765 182.48 77.839"
    >
      <path
        fill="none"
        stroke="#275186"
        strokeWidth="5"
        d="M134.81 110.84c6.118.697 4.92-.03 15.081 1.463 8.054 1.183 3.835.501 11.027 2.071l11.168 2.697c10.658 1.17 13.334-1.473 18.791-7.064l48.337-63.599"
        paintOrder="stroke"
      ></path>
      <path
        fill="#d8d8d8"
        stroke="#275186"
        strokeWidth="2"
        d="M134.36 107.67s37.649-.548 107.39-1.091M193 42.766s-.077 49.06-.482 76.551M59.28 107.99s4.154.027 68.339-.517M90.486 44.043s-.077 49.06-.482 76.551"
      ></path>
      <path
        fill="none"
        stroke="#275186"
        strokeWidth="5"
        d="M87.032 81.338c11.902-16.93 11.524-16.115 12.773-17.779.846-1.128 3.766-5.35 6.094-7.857 2.646-2.85 5.842-5.373 5.842-5.373 5.146-3.72 8.422-4.515 10.127-4.946"
        paintOrder="stroke"
      ></path>
      <path
        fill="none"
        stroke="#275186"
        strokeWidth="5"
        d="M96.01 68.768c-11.902 16.93-11.524 16.115-12.773 17.779-.846 1.128-3.766 5.35-6.094 7.857-2.646 2.85-5.842 5.373-5.842 5.373-5.146 3.72-8.422 4.515-10.127 4.946"
        paintOrder="stroke"
      ></path>
    </svg>
  ),
};

export const iconPages = {
  security: (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      width="150px"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 146.754 146.754"
      // style="enable-background:new 0 0 146.754 146.754;"
      // xml:space="preserve"
    >
      <path
        style={{ fill: "#336699" }}
        d="M78.794,146.754H67.96c-26.941,0-48.859-21.918-48.859-48.859V64.063c0-1.381,1.119-2.5,2.5-2.5
    h8.234V43.542C29.834,19.533,49.368,0,73.377,0s43.542,19.533,43.542,43.542v18.021h8.234c1.381,0,2.5,1.119,2.5,2.5v33.831
    C127.653,124.835,105.735,146.754,78.794,146.754z M24.101,66.563v31.331c0,24.184,19.675,43.859,43.859,43.859h10.834
    c24.184,0,43.859-19.675,43.859-43.859V66.563H24.101z M34.834,61.563h77.084V43.542C111.919,22.29,94.629,5,73.377,5
    C52.125,5,34.834,22.29,34.834,43.542V61.563z M77.875,120.55h-8.998c-1.381,0-2.5-1.119-2.5-2.5v-13.617
    c-3.198-2.257-5.13-5.927-5.13-9.904c0-6.688,5.441-12.129,12.129-12.129s12.129,5.441,12.129,12.129
    c0,3.978-1.932,7.647-5.13,9.904v13.617C80.375,119.431,79.256,120.55,77.875,120.55z M71.378,115.55h3.998v-12.509
    c0-0.926,0.512-1.776,1.33-2.209c2.345-1.242,3.801-3.657,3.801-6.302c0-3.931-3.198-7.129-7.129-7.129
    c-3.931,0-7.129,3.198-7.129,7.129c0,2.646,1.457,5.06,3.801,6.302c0.818,0.433,1.33,1.283,1.33,2.209V115.55z"
      />
    </svg>
  ),
  mail: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      width="130px"
      // style="enable-background:new 0 0 256 256;"
      xmlSpace="preserve"
    >
      <g
        fill="#336699"
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
      >
        <path
          className="ml0"
          d="M82.6,78.2H7.4c-4.1,0-7.4-3.3-7.4-7.4V19.2c0-4.1,3.3-7.4,7.4-7.4h75.2c4.1,0,7.4,3.3,7.4,7.4v51.7
		C90,74.9,86.7,78.2,82.6,78.2z M7.4,13.8c-3,0-5.4,2.4-5.4,5.4v51.7c0,3,2.4,5.4,5.4,5.4h75.2c3,0,5.4-2.4,5.4-5.4V19.2
		c0-3-2.4-5.4-5.4-5.4L7.4,13.8L7.4,13.8z"
        />
        <path
          className="ml0"
          d="M45,53.8c-5.1,0-9.9-2.1-13.3-5.9L2.1,15.4l1.5-1.3l29.6,32.5c3,3.3,7.4,5.2,11.9,5.2s8.8-1.9,11.9-5.2
		l29.6-32.5l1.5,1.3L58.3,47.9C54.9,51.6,50.1,53.8,45,53.8z"
        />
        <rect
          x="-3.1"
          y="59.9"
          transform="matrix(0.7052 -0.7091 0.7091 0.7052 -38.0803 30.195)"
          className="ml0"
          width="40.8"
          height="2"
        />
        <rect
          x="71.7"
          y="40.5"
          transform="matrix(0.7089 -0.7053 0.7053 0.7089 -21.7677 69.0189)"
          className="ml0"
          width="2"
          height="40.8"
        />
      </g>
    </svg>
  ),
  observability: (
    <svg
      version="1.1"
      width="100px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511 511"
      // enable-background="new 0 0 511 511"
    >
      <g style={{ fill: "#336699" }}>
        <path d="m485.729,236.892c-0.21-0.313-0.437-0.618-0.699-0.904l-.718-.783c-1.699-1.99-3.467-3.92-5.3-5.786l-96.189-105.006c-0.201-0.253-0.42-0.497-0.659-0.728-9.578-9.302-21.964-14.748-35.186-15.565-5.499-9.814-15.961-16.12-27.478-16.12-17.369,0-31.5,14.131-31.5,31.5v40 8 24.5h-65v-24.5-8-40c0-17.369-14.131-31.5-31.5-31.5-11.514,0-21.98,6.307-27.481,16.12-13.221,0.817-25.607,6.263-35.185,15.565-0.237,0.23-0.456,0.472-0.655,0.725l-96.192,105.009c-1.833,1.866-3.601,3.795-5.3,5.786l-.718,.783c-0.262,0.286-0.489,0.591-0.699,0.904-15.783,19.241-25.27,43.837-25.27,70.608 0,61.481 50.019,111.5 111.5,111.5s111.5-50.019 111.5-111.5c0-2.859-0.109-5.694-0.322-8.5h65.643c-0.213,2.806-0.322,5.641-0.322,8.5 0,61.481 50.019,111.5 111.5,111.5s111.501-50.019 111.501-111.5c0-26.771-9.487-51.367-25.271-70.608zm-182.729-113.392c0-9.098 7.402-16.5 16.5-16.5 3.445,0 6.709,1.079 9.415,2.958-10.059,2.743-18.985,8.249-25.915,15.651v-2.109zm-95,0v2.11c-6.93-7.403-15.856-12.908-25.915-15.651 2.706-1.879 5.97-2.958 9.415-2.958 9.098-0.001 16.5,7.401 16.5,16.499zm-96.5,280.5c-53.21,0-96.5-43.29-96.5-96.5 0-23.702 8.594-45.431 22.823-62.246l5.227-5.706c17.494-17.62 41.719-28.548 68.45-28.548 53.21,0 96.5,43.29 96.5,96.5s-43.29,96.5-96.5,96.5zm0-208c-11.548,0-22.691,1.765-33.174,5.039l61.278-66.894c0.012-0.013 0.024-0.026 0.036-0.039 7.554-7.166 17.428-11.106 27.86-11.106 22.332,0 40.5,18.168 40.5,40.5v8 24.5h-16.5c-0.172,0-0.342,0.006-0.511,0.017-2.181-0.209-4.427,0.533-6.077,2.218-2.898,2.959-2.849,7.708 0.111,10.606 11.432,11.196 18.88,25.313 21.697,40.7-19.601-32.082-54.951-53.541-95.22-53.541zm176.5,88h-65v-20.5c0-19.088-5.781-37.238-16.524-52.5h98.048c-10.743,15.262-16.524,33.411-16.524,52.5v20.5zm37.977-75.159c2.191-2.146 2.855-5.409 1.677-8.241-1.178-2.831-3.958-4.642-7.028-4.617l-1.176,.017h-16.45v-24.5-8c0-22.332 18.168-40.5 40.5-40.5 10.432,0 20.306,3.94 27.86,11.105 0.012,0.013 0.024,0.026 0.036,0.039l61.278,66.894c-10.483-3.273-21.626-5.038-33.174-5.038-40.269,0-75.619,21.459-95.219,53.542 2.816-15.387 10.265-29.505 21.696-40.701zm73.523,195.159c-53.21,0-96.5-43.29-96.5-96.5s43.29-96.5 96.5-96.5c26.731,0 50.956,10.928 68.449,28.547l5.227,5.706c14.23,16.816 22.824,38.545 22.824,62.247 0,53.21-43.29,96.5-96.5,96.5z" />
        <path d="m111.5,228c-43.836,0-79.5,35.664-79.5,79.5s35.664,79.5 79.5,79.5 79.5-35.664 79.5-79.5-35.664-79.5-79.5-79.5zm0,144c-35.565,0-64.5-28.935-64.5-64.5s28.935-64.5 64.5-64.5 64.5,28.935 64.5,64.5-28.935,64.5-64.5,64.5z" />
        <path d="m399.5,228c-43.836,0-79.5,35.664-79.5,79.5s35.664,79.5 79.5,79.5 79.5-35.664 79.5-79.5-35.664-79.5-79.5-79.5zm0,144c-35.565,0-64.5-28.935-64.5-64.5s28.935-64.5 64.5-64.5 64.5,28.935 64.5,64.5-28.935,64.5-64.5,64.5z" />
        <path d="m399.5,260c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5c17.92,0 32.5,14.58 32.5,32.5 0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5c0-26.191-21.309-47.5-47.5-47.5z" />
        <path d="m111.5,260c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5 7.5,7.5c17.92,0 32.5,14.58 32.5,32.5 0,4.142 3.358,7.5 7.5,7.5s7.5-3.358 7.5-7.5c0-26.191-21.309-47.5-47.5-47.5z" />
      </g>
    </svg>
  ),
  inrete: (
    <svg
      width="90px"
      height="30px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 552 90.5"
      // "enable-background:new 0 0 552 90.5;"
    >
      <g id="Page-1">
        <path
          id="Combined-Shape"
          className="logo-fill"
          d="M166,0.3l-20,90L69.4,52L61,90.2h-5l15.9-69.8L76,0.2l76.7,38.4l8.8-38.3L166,0.3z
		 M361,0.2l-1.1,5h-35l-4.5,20H356l-1.1,5h-35.6l-12.2,55h35l-1.1,5h-75l20-90H361z M467,0.2l-1.1,5h-26l-18.9,85h-39.9l18.9-85H370
		l1.1-5H467z M551,0.2l-1.1,5h-35l-4.5,20H546l-1.1,5h-35.6l-12.2,55h35l-1.1,5h-75l20-90H551z M61,0.2l-20,90H1l20-90H61z
		 M221.3,0.3l0.4,0c34.2,0,49,17.9,43,40c-5.5,20.6-27.2,33.2-54.1,34.8c10.5,7.4,24.2,10.2,35.2,10.2l0,0l-5,5
		c-8.6,0-28.3-3.7-36.8-14.4l0,0l-3.1,14.4H161l20-90h39.9c0.3,0,0.5,0,0.8,0L221.3,0.3z M220.3,5.3h-0.5l-14.5,65
		c0.2,0,0.4,0,0.6,0c27.2,0,48.1-11.2,53.2-30C264.2,21.5,250.8,5.3,220.3,5.3L220.3,5.3z"
        />
      </g>
    </svg>
  ),
  traffic2: (
    <svg width="170px" viewBox="0 0 26.458333 26.458334" version="1.1" id="svg8">
      <defs id="defs2" />

      <g
        id="layer1"
        transform="translate(0,-270.54165)"
        //  style="display:inline"
      >
        <g
          id="g1110"
          transform="matrix(1.4490874,0,0,1.2176118,-5.7005405,-61.739517)"
          className="r-icon"
        >
          <g transform="translate(-0.16667493,-0.40023445)" id="g904" className="r-icon">
            <path
              className="r-icon-1"
              id="path826-1"
              d="m 20.924581,286.50964 a 7.528739,2.9293859 0 0 1 -3.812346,2.54761 7.528739,2.9293859 0 0 1 -7.5761033,-0.0325 7.528739,2.9293859 0 0 1 -3.6672025,-2.57966"
            />
            <ellipse
              className="r-icon-1"
              id="path826"
              cx="13.392711"
              cy="281.83246"
              rx="7.5108109"
              ry="2.9296446"
            />
            <path className="r-icon-2" d="m 5.8744454,281.71002 v 5.00556" id="path847" />
            <path
              className="r-icon-2"
              d="m 20.915861,281.71106 v 5.00556"
              id="path847-9"
            />
            <path
              className="r-icon-3"
              d="m 14.410815,280.21713 -0.756797,-0.12394 2.226652,-0.72434 0.341717,1.14733 -0.70673,-0.11615 -1.069857,1.11008 -1.100672,-0.18347 z"
              id="path864"
            />
            <path
              className="r-icon-3"
              d="m 10.381971,281.72612 -0.3844203,0.39447 2.3130943,-0.51386 -0.64105,-1.21698 -0.546068,0.56791 -3.4482612,-0.57404 -0.7413226,0.77297 z"
              id="path875"
            />
            <path
              className="r-icon-3"
              d="m 12.368145,283.66794 0.879037,0.1461 -2.229737,0.54905 -0.322587,-0.97005 0.564306,0.0919 1.18339,-1.21646 1.11308,0.16813 c -0.444088,0.47435 -0.827258,0.86444 -1.187489,1.23133 z"
              id="path877"
            />
            <path
              className="r-icon-3"
              d="m 19.020028,283.1569 -3.285832,-0.54735 -0.503409,0.53128 -0.620827,-1.15182 2.38125,-0.6842 -0.521797,0.54183 c 1.209955,0.19671 2.557845,0.42814 3.289141,0.54766 0,0 -0.170595,0.17004 -0.738526,0.7626 z"
              id="path879"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  traffic1: (
    <svg width="90px" viewBox="0 6 26.458333 26.458334" version="1.1" id="svg8">
      <defs id="defs2" />
      <g id="layer1" transform="translate(0,-270.54165)">
        <g
          id="g1110"
          transform="matrix(1.4490874,0,0,1.2176118,-5.7005405,-61.739517)"
          className="rt-1"
        >
          <g transform="translate(-0.16667493,-0.40023445)" id="g904" className="rt-1">
            <ellipse
              className="r-ellipse-1"
              id="path826-1"
              cx="13.395842"
              cy="286.50964"
              rx="7.5408292"
              ry="2.9293859"
            />
            <path
              id="rect845"
              className="r-path-1"
              d="m 5.9997663,284.1901 v 2.31017 H 20.819623 v -2.31017 z"
            />
            <ellipse
              className="r-ellipse-2"
              id="path826"
              cx="13.392711"
              cy="281.83246"
              rx="7.5108109"
              ry="2.9296446"
            />
            <path className="r-path-2" d="m 5.8744454,281.71002 v 5.00556" id="path847" />
            <path
              className="r-path-3"
              d="m 20.915861,281.71106 v 5.00556"
              id="path847-9"
            />
            <path
              className="r-path-4"
              d="m 14.410815,280.21713 -0.756797,-0.12394 2.226652,-0.72434 0.341717,1.14733 -0.70673,-0.11615 -1.069857,1.11008 -1.100672,-0.18347 z"
              id="path864"
            />
            <path
              className="r-path-4"
              d="m 10.381971,281.72612 -0.3844203,0.39447 2.3130943,-0.51386 -0.64105,-1.21698 -0.546068,0.56791 -3.4482612,-0.57404 -0.7413226,0.77297 z"
              id="path875"
            />
            <path
              className="r-path-4"
              d="m 12.368145,283.66794 0.879037,0.1461 -2.229737,0.54905 -0.322587,-0.97005 0.564306,0.0919 1.18339,-1.21646 1.11308,0.16813 c -0.444088,0.47435 -0.827258,0.86444 -1.187489,1.23133 z"
              id="path877"
            />
            <path
              className="r-path-4"
              d="m 19.020028,283.1569 -3.285832,-0.54735 -0.503409,0.53128 -0.620827,-1.15182 2.38125,-0.6842 -0.521797,0.54183 c 1.209955,0.19671 2.557845,0.42814 3.289141,0.54766 0,0 -0.170595,0.17004 -0.738526,0.7626 z"
              id="path879"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  metaverse: (
    <svg
      width="200px"
      version="1.1"
      viewBox="0 0 700 700"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ fill: "#336699", strokeWidth: "1px" }}>
        <path d="m603.75 240.62h-17.5c-0.39844 0-0.78125 0.0625-1.1719 0.085938-2.3828-14.059-8.5312-27.211-17.797-38.055-9.2617-10.844-21.289-18.977-34.805-23.527l-48.594-28.207c-21.5-12.871-46.094-19.672-71.152-19.672h-125.46c-25.105 0-49.738 6.8242-71.266 19.742-0.21484 0.12891-0.42578 0.26172-0.63672 0.39844l-38.051 25.109c-15.684 3.1172-30.047 10.93-41.191 22.395-11.141 11.469-18.535 26.051-21.203 41.816-0.39062-0.023438-0.77344-0.085938-1.1719-0.085938h-17.5c-6.9609 0.007812-13.633 2.7773-18.555 7.6953-4.918 4.9219-7.6875 11.594-7.6953 18.555v70c0.007812 6.9609 2.7773 13.633 7.6953 18.555 4.9219 4.918 11.594 7.6875 18.555 7.6953h17.5c0.39844 0 0.78125-0.0625 1.1719-0.085938 3.0938 18.348 12.578 35.008 26.777 47.035 14.199 12.027 32.191 18.645 50.801 18.676h108.11c3.6172 0 7.1484-1.1211 10.105-3.2109 2.9531-2.0898 5.1875-5.0469 6.3945-8.457l8.2422-23.332h49.289l8.2461 23.332h-0.003906c1.207 3.4102 3.4414 6.3672 6.3945 8.457 2.957 2.0898 6.4883 3.2109 10.105 3.2109h108.11c18.609-0.03125 36.602-6.6484 50.801-18.676 14.199-12.027 23.684-28.688 26.777-47.035 0.39062 0.027344 0.77344 0.085938 1.1719 0.085938h17.5c6.9609-0.007812 13.633-2.7773 18.555-7.6953 4.918-4.9219 7.6875-11.594 7.6953-18.555v-70c-0.007812-6.9609-2.7773-13.633-7.6953-18.555-4.9219-4.918-11.594-7.6875-18.555-7.6953zm-490 105h-17.5c-4.832 0-8.75-3.918-8.75-8.75v-70c0-4.832 3.918-8.75 8.75-8.75h17.5zm111.26-179.63c18.809-11.285 40.328-17.246 62.262-17.246h125.46c21.934 0 43.453 5.9609 62.262 17.246l15.512 9.0039h-279.14zm343.74 184c0 16.246-6.4531 31.824-17.941 43.309-11.484 11.488-27.062 17.941-43.309 17.941h-108.11l-12.367-35h-74.039l-12.367 35h-108.11c-16.246 0-31.824-6.4531-43.309-17.941-11.488-11.484-17.941-27.062-17.941-43.309v-96.25c0-16.246 6.4531-31.824 17.941-43.309 11.484-11.488 27.062-17.941 43.309-17.941h315c16.246 0 31.824 6.4531 43.309 17.941 11.488 11.484 17.941 27.062 17.941 43.309zm43.75-13.125c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-17.5v-87.5h17.5c2.3203 0 4.5469 0.92188 6.1875 2.5625s2.5625 3.8672 2.5625 6.1875z" />
        <use x="70" y="625.625" xlinkHref="#h" />
        <use x="86.054688" y="625.625" xlinkHref="#c" />
        <use x="96.839844" y="625.625" xlinkHref="#a" />
        <use x="111.679687" y="625.625" xlinkHref="#m" />
        <use x="126.4375" y="625.625" xlinkHref="#b" />
        <use x="136.894531" y="625.625" xlinkHref="#a" />
        <use x="151.730469" y="625.625" xlinkHref="#l" />
        <use x="175.007812" y="625.625" xlinkHref="#k" />
        <use x="190.664062" y="625.625" xlinkHref="#j" />
        <use x="212.539062" y="625.625" xlinkHref="#i" />
        <use x="236.667969" y="625.625" xlinkHref="#g" />
        <use x="251.613281" y="625.625" xlinkHref="#z" />
        <use x="268.285156" y="625.625" xlinkHref="#y" />
        <use x="283.207031" y="625.625" xlinkHref="#g" />
        <use x="298.148438" y="625.625" xlinkHref="#h" />
        <use x="314.203125" y="625.625" xlinkHref="#x" />
        <use x="332.511719" y="625.625" xlinkHref="#w" />
        <use x="351.105469" y="625.625" xlinkHref="#e" />
        <use x="367.140625" y="625.625" xlinkHref="#v" />
        <use x="390.507812" y="625.625" xlinkHref="#f" />
        <use x="404.449219" y="625.625" xlinkHref="#f" />
        <use x="418.386719" y="625.625" xlinkHref="#e" />
        <use x="70" y="647.5" xlinkHref="#u" />
        <use x="79.515625" y="647.5" xlinkHref="#c" />
        <use x="90.304688" y="647.5" xlinkHref="#d" />
        <use x="105.332031" y="647.5" xlinkHref="#t" />
        <use x="135.742188" y="647.5" xlinkHref="#b" />
        <use x="146.199219" y="647.5" xlinkHref="#s" />
        <use x="161.773438" y="647.5" xlinkHref="#a" />
        <use x="184.222656" y="647.5" xlinkHref="#r" />
        <use x="202.53125" y="647.5" xlinkHref="#d" />
        <use x="217.558594" y="647.5" xlinkHref="#q" />
        <use x="233.132812" y="647.5" xlinkHref="#p" />
        <use x="256.320312" y="647.5" xlinkHref="#e" />
        <use x="272.355469" y="647.5" xlinkHref="#c" />
        <use x="283.140625" y="647.5" xlinkHref="#d" />
        <use x="298.171875" y="647.5" xlinkHref="#o" />
        <use x="305.667969" y="647.5" xlinkHref="#a" />
        <use x="320.503906" y="647.5" xlinkHref="#n" />
        <use x="333.472656" y="647.5" xlinkHref="#b" />
      </g>
    </svg>
  ),
  metaverse2: (
    <svg
      data-name="Layer 1"
      id="Layer_1"
      width="320px"
      viewBox="120 180 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="cls-1"
        d="M324.4,323.75a16.74,16.74,0,0,1-12.67-5.83c-11.05-12.82-30.39-21.32-52.41-21.32s-41.35,8.5-52.4,21.32a16.74,16.74,0,0,1-12.67,5.83h-24a9.76,9.76,0,0,1-9.77-9.76V233.46a9.76,9.76,0,0,1,9.77-9.76H341.78a9.76,9.76,0,0,1,9.77,9.76V314a9.76,9.76,0,0,1-9.77,9.76Z"
      />
      <path
        class="cls-1"
        d="M229.83,188.25h52.34a35.45,35.45,0,0,1,35.45,35.45v0a0,0,0,0,1,0,0H194.38a0,0,0,0,1,0,0v0A35.45,35.45,0,0,1,229.83,188.25Z"
      />
      <rect class="cls-1" height="38.63" width="24.99" x="135.46" y="254.03" />
      <rect class="cls-1" height="38.63" width="24.99" x="351.55" y="254.03" />
    </svg>
  ),
  aiml: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="182.48"
      height="77.839"
      viewBox="59.276 42.765 182.48 77.839"
    >
      <path
        fill="none"
        stroke="#275186"
        strokeWidth="5"
        d="M134.81 110.84c6.118.697 4.92-.03 15.081 1.463 8.054 1.183 3.835.501 11.027 2.071l11.168 2.697c10.658 1.17 13.334-1.473 18.791-7.064l48.337-63.599"
        paintOrder="stroke"
      ></path>
      <path
        fill="#d8d8d8"
        stroke="#275186"
        strokeWidth="2"
        d="M134.36 107.67s37.649-.548 107.39-1.091M193 42.766s-.077 49.06-.482 76.551M59.28 107.99s4.154.027 68.339-.517M90.486 44.043s-.077 49.06-.482 76.551"
      ></path>
      <path
        fill="none"
        stroke="#275186"
        strokeWidth="5"
        d="M87.032 81.338c11.902-16.93 11.524-16.115 12.773-17.779.846-1.128 3.766-5.35 6.094-7.857 2.646-2.85 5.842-5.373 5.842-5.373 5.146-3.72 8.422-4.515 10.127-4.946"
        paintOrder="stroke"
      ></path>
      <path
        fill="none"
        stroke="#275186"
        strokeWidth="5"
        d="M96.01 68.768c-11.902 16.93-11.524 16.115-12.773 17.779-.846 1.128-3.766 5.35-6.094 7.857-2.646 2.85-5.842 5.373-5.842 5.373-5.146 3.72-8.422 4.515-10.127 4.946"
        paintOrder="stroke"
      ></path>
    </svg>
  ),
};

export const iconService = {
  user: (
    <svg width="20px" viewBox="0 0 24 26" xmlns="http://www.w3.org/2000/svg">
      <title />
      <circle cx="12" cy="8" fill="#336699" r="4" />
      <path
        d="M20,19v1a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V19a6,6,0,0,1,6-6h4A6,6,0,0,1,20,19Z"
        fill="#336699"
      />
    </svg>
  ),
};
